var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-nav"},[_c('nav-link',{attrs:{"href":'/',"name":"Home"}}),_c('nav-link',{attrs:{"href":'/about',"name":"About"}}),_c('nav-link',{attrs:{"href":'/work',"name":"Work"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }